const translations = {
    // Authentication
    auth: {
        login: { zh: '登录', en: 'Login' },
        logout: { zh: '退出', en: 'Logout' },
        register: { zh: '注册', en: 'Register' },
        email: { zh: '邮箱', en: 'Email' },
        password: { zh: '密码', en: 'Password' },
        confirmPassword: { zh: '确认密码', en: 'Confirm Password' },
        noAccount: { zh: '还没有账号？', en: "Don't have an account?" },
        hasAccount: { zh: '已有账号？', en: 'Already have an account?' },
        goToRegister: { zh: '立即注册', en: 'Register now' },
        goToLogin: { zh: '立即登录', en: 'Login now' },
        changePassword: { zh: '修改密码', en: 'Change Password' },
        oldPassword: { zh: '旧密码', en: 'Old Password' },
        newPassword: { zh: '新密码', en: 'New Password' },
        confirmNewPassword: { zh: '确认新密码', en: 'Confirm New Password' },
        submit: { zh: '提交', en: 'Submit' },
        logging: { zh: '登录中...', en: 'Logging in...' },
        registering: { zh: '注册中...', en: 'Registering...' },
        submitting: { zh: '提交中...', en: 'Submitting...' },
        loginSuccess: { zh: '登录成功', en: 'Login successful' },
        registerSuccess: { zh: '注册成功', en: 'Registration successful' },
        passwordChanged: { zh: '密码修改成功', en: 'Password changed successfully' },
        invalidEmail: { zh: '请输入有效的邮箱地址', en: 'Please enter a valid email address' },
        passwordTooShort: { zh: '密码至少需要8个字符', en: 'Password must be at least 8 characters' },
        passwordMismatch: { zh: '两次输入的密码不一致', en: 'Passwords do not match' },
        passwordSameAsOld: { zh: '新密码不能与旧密码相同', en: 'New password cannot be the same as old password' },
        emailRequired: { zh: '请输入邮箱', en: 'Please enter email' },
        passwordRequired: { zh: '请输入密码', en: 'Please enter password' },
        newPasswordRequired: { zh: '请输入新密码', en: 'Please enter new password' },
        error: { zh: '操作失败，请重试', en: 'Operation failed, please try again' },
        user: { zh: '用户', en: 'User' },
        backToLogin: { zh: '返回登录', en: 'Back to Login' },
        backToHome: { zh: '返回首页', en: 'Back to Home' },
        loginRequired: { zh: '请先登录', en: 'Please login first' },
        adminPanel: { zh: '管理后台', en: 'Admin Panel' },
    },

    // Admin
    admin: {
        title: { zh: '管理后台', en: 'Admin Panel' },
        userManagement: { zh: '用户管理', en: 'User Management' },
        role: { zh: '角色', en: 'Role' },
        status: { zh: '状态', en: 'Status' },
        createdAt: { zh: '创建时间', en: 'Created At' },
        actions: { zh: '操作', en: 'Actions' },
        adminRole: { zh: '管理员', en: 'Admin' },
        userRole: { zh: '普通用户', en: 'User' },
        active: { zh: '正常', en: 'Active' },
        disabled: { zh: '已禁用', en: 'Disabled' },
        resetPassword: { zh: '重置密码', en: 'Reset Password' },
        resetPasswordFor: { zh: '重置密码:', en: 'Reset password for:' },
        enable: { zh: '启用', en: 'Enable' },
        disable: { zh: '禁用', en: 'Disable' },
        cancel: { zh: '取消', en: 'Cancel' },
        confirm: { zh: '确认', en: 'Confirm' },
        noAccess: { zh: '无访问权限', en: 'Access Denied' },
        noAccessDesc: { zh: '您没有权限访问此页面', en: 'You do not have permission to access this page' },
        loadError: { zh: '加载用户列表失败', en: 'Failed to load users' },
        passwordResetSuccess: { zh: '密码重置成功', en: 'Password reset successfully' },
        userDisabled: { zh: '用户已禁用', en: 'User disabled' },
        userEnabled: { zh: '用户已启用', en: 'User enabled' },
    },

    // Navigation
    nav: {
        insights: { zh: '首页', en: 'Insights' },
        feed: { zh: '资讯', en: 'Feed' },
        workbench: { zh: '工作台', en: 'Workbench' },
        aiFuture: { zh: 'AI 前沿', en: 'AI Future' },
        about: { zh: '关于', en: 'About' },
    },

    // HomePage
    home: {
        headlines: { zh: '新闻头条', en: 'Headlines' },
        upcomingEvents: { zh: '近期事件', en: 'Upcoming Events' },
        dailyBriefing: { zh: '每日简报', en: 'Daily Briefing' },
        loading: { zh: '加载中...', en: 'Loading...' },
        loadingReport: { zh: '加载报告中...', en: 'Loading report...' },
        noHeadlines: { zh: '暂无头条', en: 'No headlines yet' },
        noEvents: { zh: '暂无近期事件', en: 'No upcoming events' },
        noReport: { zh: '暂无每日报告', en: 'No daily report available yet.' },
        collapse: { zh: '收起', en: 'Collapse' },
        readFullReport: { zh: '阅读完整报告', en: 'Read Full Report' },
        hideFullReport: { zh: '收起完整报告', en: 'Hide Full Report' },
        viewFullReport: { zh: '查看完整报告', en: 'View Full Report' },
        companies: { zh: '家公司', en: 'companies' },
        up: { zh: '上涨', en: 'up' },
        down: { zh: '下跌', en: 'down' },
        refresh: { zh: '刷新', en: 'Refresh' },
        today: { zh: '今天', en: 'Today' },
        tomorrow: { zh: '明天', en: 'Tomorrow' },
        preMarket: { zh: '盘前', en: 'Pre-market' },
        afterClose: { zh: '盘后', en: 'After-close' },
        during: { zh: '盘中', en: 'During' },
        earnings: { zh: '财报', en: 'Earnings' },
        revEstimate: { zh: '营收预期', en: 'Rev Est.' },
        bullish: { zh: '看多', en: '▲ Bullish' },
        bearish: { zh: '看空', en: '▼ Bearish' },
        neutral: { zh: '中性', en: '— Neutral' },
        score: { zh: '评分', en: 'Score' },
    },

    // FeedPage
    feed: {
        aiSummary: { zh: 'AI智能摘要', en: 'AI Summary' },
        keyMetrics: { zh: '关键指标', en: 'Key Metrics' },
        marketImpact: { zh: '市场影响', en: 'Market Impact' },
        readMore: { zh: '阅读全文', en: 'Read More' },
        original: { zh: '原文', en: 'Source' },
        aiTrends: { zh: 'AI 动态', en: 'AI Trends' },
        techFrontier: { zh: '科技最前线', en: 'Tech Frontier' },
        hotTech: { zh: '热门技术', en: 'Hot Tech' },
        loadingFeeds: { zh: '加载资讯中...', en: 'Loading feeds...' },
        noFeeds: { zh: '暂无资讯', en: 'No feeds found' },
        loadMore: { zh: '加载更多', en: 'Load More' },
        loadingMore: { zh: '加载中...', en: 'Loading...' },
        searchPlaceholder: { zh: '搜索资讯...', en: 'Search feeds...' },
        allSources: { zh: '全部来源', en: 'All Sources' },
        noAiSummary: { zh: '暂无 AI 动态汇总', en: 'No AI trends summary' },
        noTechSummary: { zh: '暂无科技新闻汇总', en: 'No tech news summary' },
        noHackerNews: { zh: '暂无 HackerNews 数据', en: 'No HackerNews data' },
        pastDays: { zh: '过去 {days} 天 {count} 条动态', en: '{count} events in past {days} days' },
        pastDaysTech: { zh: '过去 {days} 天 {count} 条科技新闻', en: '{count} tech news in past {days} days' },
        revenue: { zh: '营收', en: 'Revenue' },
        eps: { zh: 'EPS', en: 'EPS' },
        stockPrice: { zh: '股价', en: 'Stock' },
        guidance: { zh: '指引', en: 'Guidance' },
        impactLevel: { zh: '影响级别', en: 'Impact' },
        sentiment: { zh: '情绪', en: 'Sentiment' },
        relatedStocks: { zh: '相关股票', en: 'Related Stocks' },
        loadError: { zh: '资讯加载失败', en: 'Failed to load feeds' },
    },

    // WorkbenchPage
    workbench: {
        myWatchlist: { zh: '我的自选', en: 'My Watchlist' },
        addSymbol: { zh: '添加代码...', en: 'Add symbol...' },
        add: { zh: '添加', en: 'Add' },
        trending: { zh: '热门', en: 'Trending' },
        todaysKeyEvents: { zh: '今日要闻', en: "Today's Key Events" },
        watchlistPulse: { zh: '持仓脉搏', en: 'Watchlist Pulse' },
        noEventsToday: { zh: '今日暂无事件', en: 'No events today' },
        noPulseNews: { zh: '暂无持仓相关新闻', en: 'No recent news for watched companies' },
        relatedToYou: { zh: '与你相关', en: 'Related to You' },
        otherEvents: { zh: '其他事件', en: 'Other Events' },
        earningsAiEvents: { zh: '财报与 AI 事件', en: 'Earnings & AI Events' },
        updating: { zh: '更新中...', en: 'Updating...' },
        investmentDiscovery: { zh: '投资发现', en: 'Investment Discovery' },
        smartMoneyMoves: { zh: '聪明钱动向', en: 'Smart Money Moves' },
        guruPortfolio: { zh: '大师持仓', en: 'Guru Portfolio' },
        investmentSignals: { zh: '投资信号', en: 'Investment Signals' },
        signalsDesc: { zh: '基于聪明钱 + 大师数据自动聚合', en: 'Auto-aggregated from Smart Money + Guru data' },
        consensusHoldings: { zh: '共识持仓', en: 'Consensus Holdings' },
        bigBuys: { zh: '大额买入', en: 'Big Buys' },
        exitAlerts: { zh: '退出信号', en: 'Exit Alerts' },
        noOverlap: { zh: '无重叠持仓', en: 'No overlapping positions' },
        noBigBuys: { zh: '暂无大额买入', en: 'No significant buys' },
        noExitSignals: { zh: '暂无退出信号', en: 'No exit signals' },
        noChanges: { zh: '暂无近期变动', en: 'No recent changes' },
        noHoldings: { zh: '暂无持仓数据', en: 'No holdings data' },
        bullBear: { zh: '多空分析', en: 'Bull / Bear' },
        bullish: { zh: '看多', en: 'Bullish' },
        bearish: { zh: '看空', en: 'Bearish' },
        noBullish: { zh: '暂无看多信号', en: 'No bullish signals' },
        noBearish: { zh: '暂无看空信号', en: 'No bearish signals' },
        catalysts: { zh: '催化剂', en: 'Catalysts' },
        risks: { zh: '风险', en: 'Risks' },
        relatedNews: { zh: '相关新闻', en: 'Related News' },
        noNews: { zh: '暂无新闻', en: 'No recent news' },
        loadingProfile: { zh: '加载中...', en: 'Loading profile...' },
        noProfile: { zh: '暂无数据', en: 'No profile data' },
        marketCap: { zh: '市值', en: 'Market Cap' },
        peRatio: { zh: '市盈率', en: 'P/E Ratio' },
        epsLabel: { zh: 'EPS', en: 'EPS' },
        dividend: { zh: '股息', en: 'Dividend' },
        high52w: { zh: '52 周高', en: '52W High' },
        low52w: { zh: '52 周低', en: '52W Low' },
        employees: { zh: '员工数', en: 'Employees' },
        beta: { zh: 'Beta', en: 'Beta' },
        loadingChart: { zh: '加载图表...', en: 'Loading chart...' },
        aiAnalysis: { zh: 'AI 分析', en: 'AI analysis' },
        increase: { zh: '增持', en: '↑ Increase' },
        decrease: { zh: '减持', en: '↓ Decrease' },
        portfolio: {
            title: { zh: '组合收益对比', en: 'Portfolio Returns' },
            addSymbol: { zh: '添加代码', en: 'Add symbol' },
            portfolioLabel: { zh: '组合', en: 'Portfolio' },
            selectHint: { zh: '选择股票构建收益对比组合', en: 'Select stocks to compare returns' },
            noData: { zh: '选择股票后显示收益图', en: 'Select stocks to see returns' },
            custom: { zh: '自定义', en: 'Custom' },
            clearAll: { zh: '清空', en: 'Clear' },
            saveCurrent: { zh: '保存组合', en: 'Save' },
            namePrompt: { zh: '输入组合名称', en: 'Portfolio name' },
        },
    },

    // AIFuturePage
    aiFuture: {
        roadToAgi: { zh: '前沿模型能力路线图', en: 'Frontier Model Capability Roadmap' },
        aiLabValuations: { zh: 'AI 实验室估值', en: 'AI Lab Valuations' },
        privateFunding: { zh: '私募融资轮次', en: 'Private funding rounds' },
        tokenCost: { zh: 'Token 成本', en: 'Token Cost' },
        trainingCompute: { zh: '训练算力', en: 'Training Compute' },
        aiDataRadar: { zh: 'AI 数据雷达', en: 'AI Data Radar' },
        aiDataRadarSubtitle: { zh: '模型与价格使用来源快照；流量、广告、基建和供应链继续标注来源等级，后续由 InvestFlow 自动刷新。', en: 'Model and pricing use source snapshots; traffic, ads, infrastructure, and supply chain keep source readiness labels until InvestFlow automates refreshes.' },
        mockData: { zh: 'Mock 数据', en: 'Mock Data' },
        partialData: { zh: '来源快照', en: 'Source Snapshot' },
        liveData: { zh: '实时数据', en: 'Live Data' },
        updated: { zh: '更新', en: 'Updated' },
        source: { zh: '来源', en: 'Source' },
        confidence: { zh: '可信度', en: 'Confidence' },
        demandSignals: { zh: 'AI 需求指标', en: 'AI Demand Signals' },
        trafficSearchTokensAds: { zh: '流量 · 搜索 · Token · 广告', en: 'Traffic · Search · Tokens · Ads' },
        modelRanking: { zh: '模型排名', en: 'Model Ranking' },
        qualitySpeedPrice: { zh: '质量 · 速度 · 价格效率', en: 'Quality · Speed · Price' },
        tokenEconomicsPanel: { zh: 'Token 经济', en: 'Token Economics' },
        infraSupplyPanel: { zh: '基建与供应链', en: 'Infrastructure & Supply Chain' },
        capexMemoryPower: { zh: 'CapEx · 内存 · 电力', en: 'CapEx · Memory · Power' },
        sourceReadiness: { zh: '数据源准备度', en: 'Source Readiness' },
        freeFirstPaidLater: { zh: '先免费，后评估付费', en: 'Free first, paid later' },
        mockConfidenceNote: { zh: '模型和价格已按来源快照更新；流量、广告、基建和供应链指标仍需接入 InvestFlow 自动采集后才可作为实时数据。', en: 'Model and pricing values are updated as source snapshots; traffic, ads, infrastructure, and supply-chain metrics still need InvestFlow collection before they are live data.' },
        sixPeriodHistoryTrend: { zh: '6期历史趋势', en: '6-period history trend' },
        aiStockTracker: { zh: 'AI 股票追踪', en: 'AI Stock Tracker' },
        aiEcosystemMap: { zh: 'AI 生态图谱', en: 'AI Ecosystem Map' },
        aiIndustryPulse: { zh: 'AI 行业脉搏', en: 'AI Industry Pulse' },
        aiIndustryNews: { zh: 'AI 行业新闻', en: 'AI Industry News' },
        privateCompanyProfiles: { zh: '私有公司档案', en: 'Private Company Profiles' },
        loading: { zh: '加载中...', en: 'Loading...' },
        noData: { zh: '暂无数据', en: 'No data' },
        loadingSummary: { zh: '加载摘要中...', en: 'Loading summary...' },
        noSummary: { zh: '暂无摘要', en: 'No summary available' },
        loadingEvents: { zh: '加载事件中...', en: 'Loading events...' },
        noAiEvents: { zh: '暂无 AI 事件', en: 'No AI events' },
        loadingChart: { zh: '加载图表中...', en: 'Loading chart...' },
        valuation: { zh: '估值', en: 'Valuation' },
        founded: { zh: '成立于', en: 'Founded' },
        ceo: { zh: 'CEO', en: 'CEO' },
        totalFunding: { zh: '总融资', en: 'Total Funding' },
        latestRound: { zh: '最新轮次', en: 'Latest Round' },
        keyInvestors: { zh: '主要投资方', en: 'Key Investors' },
        stockLoadError: { zh: '股票数据加载失败', en: 'Failed to load stock data' },
        eventsLoadError: { zh: 'AI 事件加载失败', en: 'Failed to load AI events' },
        summaryLoadError: { zh: '摘要加载失败', en: 'Failed to load summary' },
    },
};

export default translations;
